import React from "react";

export default function LazyImage({
  src,
  alt,
  loading = "lazy",
  decoding = "async",
  ...props
}) {
  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      decoding={decoding}
      {...props}
    />
  );
}
